import { MenuOutlined as AntDMenuOutlined } from "@ant-design/icons"
import styled from "styled-components"

export const MenuOutlined = styled(AntDMenuOutlined)`
  font-size: 1.5rem;
  color: ${props => props.theme.color.iconColor.whiteColor1};
`
